/**
 * Python variable name validation utilities
 *
 * Based on Python's official variable naming rules:
 * - Variable names can be any length
 * - Can consist of uppercase and lowercase letters (A-Z, a-z), digits (0-9), and underscore (_)
 * - The first character cannot be a digit
 * - Must start with a letter or underscore
 */
import { capitalize } from "lodash-es";

// Python variable name matcher pattern from existing codebase
export const PythonVariableNameMatcher = "[a-zA-Z_][a-zA-Z0-9_]*";
export const PythonKeyMatcher = "[a-zA-Z][a-zA-Z0-9_]*";

// Create regex from the matcher pattern
export const PYTHON_VARIABLE_NAME_REGEX = new RegExp(
  `^${PythonVariableNameMatcher}$`,
);
export const PYTHON_KEY_REGEX = new RegExp(`^${PythonKeyMatcher}$`);
/**
 * Helper function to convert snake_case key to human-readable display name
 * @param str - The snake_case string to convert
 * @returns Human-readable display name
 */
export const unslugify = (str: string): string => {
  return capitalize(str.split("_").join(" "));
};

/**
 * Checks if a string is a valid Python variable name (boolean return)
 * @param value - The string to check
 * @returns true if valid, false if invalid
 */
export const isLikePythonVariable = (value: string): boolean => {
  return PYTHON_VARIABLE_NAME_REGEX.test(value);
};

export const isLikePythonKey = (value: string): boolean => {
  return PYTHON_KEY_REGEX.test(value);
};
